<p-dialog header="Confirmation Preview" [(visible)]="showPrintConfirmations" [style]="{width: '75vw', height: '75vh'}" [baseZIndex]="10000" [modal]="true">
    <div style="margin-top:5px;padding:0px !important">
    <div class="field mb-4 col-12" id="confToPrint">
        <div style="width:100%" [innerHTML]="confHTML | safe: 'html'">
        </div>
    </div>
  </div>
  <ng-template pTemplate="footer" id="noprint" class="noprint">
    <p-button icon="pi pi-print" label="Print" styleClass="p-button p-button-success" (click)="generatePDF()"></p-button>
    &nbsp;
    <p-button icon="pi pi-times" label="Close" styleClass="p-button p-button-success" (click)="showPrintConfirmations = false;"></p-button>
  </ng-template>
</p-dialog>

<div *ngIf="BookingSummary" id="confToPrint" style="padding:30px;font-size:30px;position: absolute;left: -10000px;">

    <div style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Sales ID</b> : {{BookingSummary.bookingIdHR}}
    </div>

    <div style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-calendar" style="margin-right: 10px;"></span>
        <b>Start Date/Time</b> : {{BookingSummary.startTime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}
    </div>

    <div style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-user" style="margin-right: 10px;"></span>
        <b>Customer</b> : {{BookingSummary.customerAddress}}
    </div>
    <div style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-box" style="margin-right: 10px;"></span>
        <b>Package</b> : {{BookingSummary.packageName}}
    </div>
    <div style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-users" style="margin-right: 10px;"></span>
        <b>Admissions</b> : {{BookingSummary.admissions}}
    </div>
    
    <div *ngIf="BookingSummary.upgrade != '' && BookingSummary.upgrade != null && BookingSummary.upgrade != undefined" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-arrow-up" style="margin-right: 10px;"></span>
        <b>Upgrade</b> : {{BookingSummary.upgradetext}}
    </div>

    <div *ngIf="BookingSummary.extras != ''" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-star" style="margin-right: 10px;"></span>
        <b>Extras</b> : {{BookingSummary.extras}}
    </div>

    <div *ngIf="BookingSummary.totalbookingfees > 0" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Booking Fee</b> : {{BookingSummary.totalbookingfees | currency:CurrencySymbol }}
    </div>

    <!-- A series is paid as a whole, so one date's money says nothing useful. -->
    <ng-container *ngIf="!seriesLocked">
    <div style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Sales Value</b> : {{BookingSummary.total | currency:CurrencySymbol }}
    </div>

    <div *ngIf="BookingSummary.totaldiscounts > 0" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Discounts</b> : {{BookingSummary.totaldiscounts | currency:CurrencySymbol }}
    </div>

    <div *ngIf="BookingSummary.outstanding > 0" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Paid</b> : <span>{{BookingSummary.paid | currency:CurrencySymbol }}</span>
    </div>
    <div *ngIf="BookingSummary.outstanding <= 0" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Paid</b> : {{BookingSummary.paid | currency:CurrencySymbol }}
    </div>

    <div *ngIf="BookingSummary.outstanding > 0" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Outstanding</b> : <span style="color: red; font-weight: bold;">{{BookingSummary.outstanding | currency:CurrencySymbol }}</span>
    </div>
    <div *ngIf="BookingSummary.outstanding <= 0" style="width:100%; margin-bottom: 15px;">
        <span class="pi pi-pound" style="margin-right: 10px;"></span>
        <b>Outstanding</b> : {{BookingSummary.outstanding | currency:CurrencySymbol }}
    </div>
    </ng-container>

    <div style="width:100%; margin-bottom: 15px;">
    
    <div *ngIf="SummaryItinerary">
        <span class="pi pi-list" style="margin-right: 10px;"></span><b>Itinerary</b>:

        <div style="margin-top:5px; margin-bottom:10px;">
            <table [cellPadding]="3" >

                <tr style="border-bottom: 1px solid #dddddd" *ngFor="let itin of (NewBooking.itineraryEX || [])">
                    <td>&nbsp;</td>
                    <td>
                        <b>{{itin.resource}}</b>
                    </td>
                    <td>
                        {{itin.starttime}}
                    </td>
                    <td >
                        {{itin.people}}&nbsp;people
                    </td>

                </tr>

                <tr style="border-bottom: 1px solid #dddddd">
                    <td>&nbsp;</td>
                    <td>
                        <b>End:</b>
                    </td>
                    <td>
                        {{addMs(BookingSummary.endTime, 1)| date:'HH:mm' : 'UTC'}}
                    </td>
                    <td>&nbsp;</td>
                </tr>
            </table>
        </div>
    </div>
</div>
</div>

<div *ngIf="!AccessAllowed && CompletedLoading">
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
</div>

<p-dialog header="Subscription Required" [(visible)]="showSubscriptionlWarning" [style]="{width: '45vw'}" [baseZIndex]="10000"  [modal]="true">
    <div style="width:17%; float:left;">
        <img src="https://dashboard.wannabook.online/assets/images/email.png" style="width: 100%;">
        <div style="width:100%;margin-top:10px;"></div>
    </div>
    <div class="field mb-4 col-12" style="float:left;width:80%">
        <p>You need to be subscribed to one of our Communication products to use this feature<br><br>
        Clicking the button below will take you to our Additional Products page, once you are subscribed to a Communications product, you can return to this page and try again.</p>
    </div>
  <ng-template pTemplate="footer">
    <p-button icon="pi pi-shopping-bag" label="Subscribe" styleClass="p-button p-button-success" (click)="subscribe()"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="Refund Payment" [(visible)]="displayModalRefund" [style]="{width: '50vw'}" [baseZIndex]="10000"  [modal]="true">
    <div class="surface-card p-4 shadow-2 border-round" style="margin-top:5px;">
    <div class="field mb-4 col-12">
        <label for="venueclosingname" class="font-medium">Refund Value</label>&nbsp;
        <br>
        <p-inputNumber [(ngModel)]="RefundPayment" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputNumber>
    </div>
    <div *ngIf="!RefundPaymentValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Refund value.</div>

    <div class="field mb-4 col-12">
        <label for="reason" class="font-medium">Refund Reason</label>&nbsp;
        <br>
        <textarea pInputText type="text" [(ngModel)]="RefundReason" style="width:100%; height: 100px;"></textarea>
    </div>
    <div *ngIf="!RefundTextValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Reason.</div>

    <p><b>Items will be refunded to the same payment type as the payment was originally made in.</b></p>
</div>
  <ng-template pTemplate="footer">
      <p-button icon="pi pi-check" label="Refund" styleClass="p-button p-button-success" (click)="doRefund()"></p-button>
      &nbsp;
      <p-button icon="pi pi-times" (click)="displayModalRefund=false" label="Cancel" styleClass="p-button p-button-danger" (click)="closeRefund()"></p-button>
  </ng-template>

</p-dialog>

<p-dialog [(visible)]="showTerminalWaiting" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '380px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:32px 24px; text-align:center;">
        <i class="pi pi-spin pi-spinner" style="font-size:3rem; color:#2563eb;"></i>
        <div style="font-size:1.2rem; font-weight:700; color:#111827;">Waiting for Terminal</div>
        <div style="font-size:0.95rem; color:#6b7280;">Please complete the payment on the card reader.</div>
        <button pButton pRipple type="button" label="Cancel Payment" icon="pi pi-times"
            class="p-button p-button-secondary"
            style="min-width:160px;"
            (click)="cancelTerminalPayment()">
        </button>
    </div>
</p-dialog>

<p-dialog [(visible)]="showTerminalBusyDialog" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false" [style]="{width: '420px'}">
    <div style="display:flex; flex-direction:column; align-items:center; gap:20px; padding:28px 24px 8px; text-align:center;">
        <div style="width:60px; height:60px; border-radius:50%; background:#fff7ed; display:flex; align-items:center; justify-content:center;">
            <i class="pi pi-exclamation-triangle" style="font-size:2rem; color:#d97706;"></i>
        </div>
        <div style="font-size:1.2rem; font-weight:700; color:#111827;">Terminal In Use</div>
        <div style="font-size:0.95rem; color:#6b7280; line-height:1.5;">This terminal is currently processing another transaction. Would you like to wait for it to finish, or clear the terminal and retry?</div>
    </div>
    <ng-template pTemplate="footer">
        <div style="display:flex; justify-content:center; gap:10px; padding-bottom:8px;">
            <button pButton pRipple type="button" label="Wait" icon="pi pi-clock"
                class="p-button p-button-secondary p-button-outlined"
                style="min-width:120px;"
                (click)="waitForTerminal()">
            </button>
            <button pButton pRipple type="button" label="Clear Terminal" icon="pi pi-replay"
                class="p-button p-button-danger"
                style="min-width:150px;"
                (click)="clearTerminalAndRetryPayment()">
            </button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Disable Reason" [(visible)]="showDisableReason" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true">
    <div class="field mb-4 col-12">
        <div>
            <textarea pInputText type="text" style="width:100%; height: 15vw;" [(ngModel)]="disableNotes"></textarea>
        </div>
    </div>

  <ng-template pTemplate="footer">
    <p-button icon="pi pi-pencil" label="Disable Booking" styleClass="p-button p-button-success" (click)="disableBooking()"></p-button>
  </ng-template>

</p-dialog>

<p-dialog header="No Availability" [(visible)]="showEnableNoAvailability" [style]="{width: '50vw'}" [baseZIndex]="10000" [modal]="true" [closable]="false">
    <div class="field mb-4 col-12">
        <p style="font-size: 1.1rem; margin-bottom: 1rem;">
            There is no availability for this booking at its current time. Enabling it may cause overbooking.
        </p>
        <p style="color: #ef4444; font-weight: bold;">
            Warning: Enabling this booking will place it in an overbooked slot.
        </p>
        <p>Do you still want to enable this booking?</p>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" label="Enable Anyway" styleClass="p-button p-button-warning" (click)="confirmEnableAnyway()"></p-button>
        &nbsp;
        <p-button icon="pi pi-times" label="Cancel" styleClass="p-button p-button-secondary" (click)="showEnableNoAvailability = false"></p-button>
    </ng-template>
</p-dialog>

<p-dialog header="Reason for Enabling" [(visible)]="showEnableReason" [style]="{width: '50vw', height: '50vh'}" [baseZIndex]="10000" [modal]="true" [closable]="false">
    <div class="field mb-4 col-12">
        <p style="margin-bottom: 0.5rem;">Please provide a reason for enabling this booking despite no availability:</p>
        <div>
            <textarea pInputText type="text" style="width:100%; height: 12vw;" [(ngModel)]="enableReason"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" label="Enable Booking" styleClass="p-button p-button-success" [disabled]="!enableReason" (click)="doEnableWithReason()"></p-button>
    </ng-template>
</p-dialog>

<div *ngIf="AccessAllowed" style="padding: 1rem;">
    <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:10px; flex-wrap:wrap; gap:8px;">
        <h3 style="margin:0;">Edit Booking <span *ngIf="NewBooking.disabled" style="color:red;">&nbsp;- This Booking is Disabled</span></h3>
        <div style="display:flex; gap:8px; flex-wrap:wrap;">
            <button *ngIf="showReturnToSearch" pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToSearch()">
                <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
                <span>Return to Search Results</span>
            </button>
            <button *ngIf="ShowReturnToDaysheets" pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToDaysheet()">
                <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
                <span>Return to Daysheet</span>
            </button>
            <button *ngIf="ShowReturnToList" pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToList()">
                <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
                <span>Return to List</span>
            </button>
            <button *ngIf="ShowReturnToBooking" pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToBooking()">
                <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
                <span>Return to Booking</span>
            </button>
            <button *ngIf="FromEvents" pButton type="button" style="height:40px;" class="p-button p-button-outlined p-button-secondary" (click)="returnToEvents()">
                <span class="pi pi-chevron-left" style="margin-right:6px;"></span>
                <span>Return to Events</span>
            </button>
        </div>
    </div>

    <h3 *ngIf="NewBooking.awaitingpayment && !paymentLinkExpired" style="font-weight: normal;background: #22c55e;padding: 14px;border-radius: 13px;color: white;text-align: center;font-size: 24px;margin-bottom: 20px;">A Payment link has been sent for this booking (Sent at: {{NewBooking.paymentlinksentdate | date:'dd/MM/yyyy HH:mm:ss'}})</h3>

    <h3 *ngIf="NewBooking.awaitingpayment && paymentLinkExpired" style="font-weight: normal;background: #EF4444;padding: 14px;border-radius: 13px;color: white;text-align: center;font-size: 24px;margin-bottom: 20px;">The Payment link for this booking has expired (Sent at: {{NewBooking.paymentlinksentdate | date:'dd/MM/yyyy HH:mm:ss'}})</h3>

    <!-- A repeatable package books one booking per date, all sharing a seriesid. Each date is
         edited on its own, so the others are listed here with a way to open them. -->
    <div *ngIf="NewBooking.seriesid" style="background:#f5f3ff;border:1px solid #c4b5fd;border-radius:13px;padding:14px;margin-bottom:20px;">
        <div style="font-size:18px;font-weight:bold;margin-bottom:10px;">
            <span class="pi pi-lock" style="margin-right:10px;"></span>
            This booking is one date of a repeating package and cannot be changed on its own
            <span *ngIf="NewBooking.seriestype == 'ALL'" style="font-weight:normal;">&nbsp;(all of the package's dates were booked)</span>
            <span *ngIf="NewBooking.seriestype == 'SOME'" style="font-weight:normal;">&nbsp;(some of the package's dates were booked)</span>
        </div>

        <div style="margin-bottom:12px;">
            Every date was booked together, so they have to be changed together. This date is shown for reference only - nothing on it can be edited, and no payment or voucher can be taken against it.
        </div>

        <div style="margin-bottom:14px;">
            <button pButton type="button" style="height:40px;" class="p-button p-button-help" (click)="editSeries()">
                <span class="pi pi-sync" style="margin-right:8px;"></span>
                <span>Edit Series</span>
            </button>
        </div>

        <div *ngIf="seriesBookings.length > 0">
            <div style="margin-bottom:6px;">The other dates in this series:</div>
            <table [cellPadding]="4">
                <tr style="border-bottom: 1px solid #ddd6fe;" *ngFor="let seriesitem of seriesBookings">
                    <td><b>{{seriesitem.startTime | date:'EEE dd/MM/yyyy HH:mm' : 'UTC'}}</b></td>
                    <td>{{seriesitem.bookingIdHR}}</td>
                    <!-- No money per date: a series is paid as a whole, so it is shown on Edit Series. -->
                    <td>
                        <span *ngIf="seriesitem.disabled" style="color:#b91c1c;font-weight:bold;">Disabled</span>
                    </td>
                    <td>
                        <button pButton type="button" style="height:32px;" class="p-button-sm p-button-outlined p-button-secondary" (click)="openSeriesBooking(seriesitem.bookingId)">
                            <span class="pi pi-eye" style="margin-right:6px;"></span>
                            <span>View this date</span>
                        </button>
                    </td>
                </tr>
            </table>
        </div>

        <div *ngIf="seriesLookupDone && seriesBookings.length == 0" style="color:#6d28d9;">
            No other dates were found for this series.
        </div>
    </div>

    <p-tabView [(activeIndex)]="outerActiveIndex">
        <p-tabPanel header="Edit">
            <ng-template pTemplate="header">
                <i class="pi pi-pencil" style="margin-right: 5px;"></i>
                <span>Edit</span>
            </ng-template>

        <div class="grid">
          <div class="col-12 md:col-8">
            <div class="surface-card p-4 shadow-2 border-round">
        <!-- A date of a series is shown but not editable: the class stops anything in the tab
             contents being clicked or typed into, while the tabs themselves still change. -->
        <p-tabView [style]="{'width':'100%'}" [ngClass]="{'series-locked': seriesLocked}" [(activeIndex)]="activeIndex" (onChange)="checkTab()" >
            <p-tabPanel header="Details">
                <ng-template pTemplate="header">
                    <i class="pi pi-list" style="margin-right: 5px;"></i>
                    <span>Details</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div *ngIf="SelectedDate">
                        <div><label for="ddlPackage" class="font-medium">Date</label></div>
                        <div>
                            <p-calendar [selectOtherMonths]="true" [(ngModel)]="SelectedDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="doneDate()" [disabled]="paymentLinkExpired"></p-calendar>
                            
                            <span style="margin-left:20px;">Time: {{NewBooking.startTime | date:'HH:mm' : 'UTC'}}</span> &nbsp; 
                            <!--<button pButton type="button" style="height: 50px;margin-top: 20px;" class="p-button p-button">
                                <span class="pi pi-clock" style="margin-right:8px;"></span>
                                <span>Change Booking Time</span>            
                            </button>-->
                            &nbsp;
                            <button *ngIf="!NewBooking.disabled" pButton type="button" style="height: 50px;margin-top: 20px;" class="p-button p-button p-button-danger" (click)="showDisableMessage()">
                                <span class="pi pi-times" style="margin-right:8px;"></span>
                                <span>Disable this Booking</span>            
                            </button>

                            <button *ngIf="NewBooking.disabled && !paymentLinkExpired" pButton type="button" style="height: 50px;margin-top: 20px;" class="p-button p-button p-button-success" (click)="enableBooking()">
                                <span class="pi pi-check" style="margin-right:8px;"></span>
                                <span>Enable this Booking</span>            
                            </button>
                        </div>
                    </div>

                    <div *ngIf="packages" style="margin-top:20px">
                        <label for="ddlPackage" class="font-medium">Package</label><br>
                        <p-dropdown [options]="packages" [(ngModel)]="SelectedPackage" placeholder="Select a Package" [showClear]="true" optionLabel="name" (onChange)="packageChanged()"></p-dropdown>
                    </div>

                    <!-- <div class="field mb-4 col-12" style="margin-left: -8px; margin-top: 20px;">
                        <label for="newsettings" class="font-medium">Use New Settings for Package</label>
                        <p-selectButton id="newsettings" [style]="{'width': '560px'}" [options]="stateOptionsNewSettings" [(ngModel)]="useNewPackageSettings" (onChange)="packageChanged()"></p-selectButton>
                    </div> -->

                    <div *ngIf="ShowAdmissions" style="margin-top:20px">
                        <label for="ddlPackage" class="font-medium">Admissions</label>
                        <div class="packageSelection clr" *ngFor="let a of (SelectedAdmissions)">
                            <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                            {{a.bookingwizardtext}}:
                            </div>
                            <div class="packageSelect" style="max-width: 1000px; margin-bottom:20px;">
                            <!-- <p-inputNumber [(ngModel)]="SelectedAdmissions[a.index].noofpeople" [disabled]="SelectedAdmissions[a.index].fixed" [id]="'ad'+a.name" [showButtons]="true" max="{{a.max}}" min="{{a.min}}" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="sumAdmissions()" (onBlur)="sumAdmissions()"></p-inputNumber> -->
                            <p-inputNumber [(ngModel)]="SelectedAdmissions[a.index].noofpeople" [disabled]="a.fixed" [id]="'ad'+a.name" [showButtons]="true" [max]="a.max" [min]="a.min" buttonLayout="horizontal" spinnerMode="horizontal"  (onInput)="admissionsChanged()" (onBlur)="admissionsChanged()"></p-inputNumber>
                            </div>
                        </div>
                    </div>
<!--AdmissionEnabled-->
                    <div *ngIf="partyroomsVisible && hasEditableResources" class="field mb-4 col-12">
                        <label for="ddlPackage" class="font-medium">Additional Resources</label>

                        <div class="grid formgrid p-fluid">
                            <div class="field mb-4 col-12">
                                
                                <div class="packageSelection clr" *ngFor="let a of (PossibleResources)">
                                    <div *ngIf="a.mode == 'COMPLEX' && a.selectionmode != 'SYSTEMANY' && a.selectionmode != 'SYSTEMLIST' && a.selectionmode != ''"  class="PackageSelectLabel" style="margin-bottom: 8px;">
                                        <div style="margin-bottom:10px;" *ngIf="!a.optional"><b>Please select one of these {{a.name}}:</b></div>
                                        
                                        <div style="margin-bottom:10px;" *ngIf="a.optional">
                                            <div style="width:55px; float:left;"><p-inputSwitch [(ngModel)]="OptionalResources[a.orderindex]"></p-inputSwitch></div>
                                            <div *ngIf="!a.isconstructed == true" style="width:400px;float:left"><b>Would you like a {{a.name}}?</b></div>
                                            <div *ngIf="a.isconstructed == true" style="width:400px;float:left"><b>Would you like to choose a {{a.name}}?</b></div>
                                            <div style="clear:both;"></div>
                                        </div>
            
                                        <div *ngIf="a.optional && OptionalResources[a.orderindex] && a.isconstructed == true" >
                                            <div style="margin-bottom: 5px; max-width:400px;" class="packageSelection clr" *ngFor="let r of (a.selectableresources)">
                                                <!--<p-radioButton style="margin-top:5px; margin-bottom: 5px; margin-left: 10px" name="{{a.groupname}}" value="{{r}}" label="{{r.name}}" [(ngModel)]="SelectedSeletableResource[a.orderindex][r.orderindex]" (onClick)="donePartyRooms()"></p-radioButton>-->
                                                <p-toggleButton *ngIf="!r.disabled" style="width: 22rem; display: block;" [(ngModel)]="r.ignore" onLabel="{{r.name}} - Selected" offLabel="{{r.name}}" (onChange)="toggleButton(a,r)"></p-toggleButton>
                                            </div>
                                            <div style="clear:both;"></div>
                                        </div>

                                        <div *ngIf="!a.optional" >
                                            <div style="margin-bottom: 5px; max-width:400px;" class="packageSelection clr" *ngFor="let r of (a.selectableresources)">
                                                <!--<p-radioButton style="margin-top:5px; margin-bottom: 5px; margin-left: 10px" name="{{a.groupname}}" value="{{r}}" label="{{r.name}}" [(ngModel)]="SelectedSeletableResource[a.orderindex][r.orderindex]" (onClick)="donePartyRooms()"></p-radioButton>-->
                                                <p-toggleButton *ngIf="!r.disabled" style="width: 22rem; display: block;" [(ngModel)]="r.ignore" onLabel="{{r.name}} - Selected" offLabel="{{r.name}}" (onChange)="toggleButton(a,r)"></p-toggleButton>
                                            </div>
                                        </div>

                                        <div *ngIf="!validselection[a.orderindex] && validselection[a.orderindex] != null" class="text-danger" Style="margin-left:10px;">
                                            <div style="clear:both;"></div>
                                            <span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select from the list above.
                                        </div>
        
                                        <div *ngIf="a.quantityselector == 'CUSTOM' && a.optional" Style="margin-left:10px;">
                                            <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                                How many of the above resource would you like?
                                            </div>
                                            <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                            <p-inputNumber [(ngModel)]="a.quantity" [showButtons]="true" max="100" min="1" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="donePartyRooms()"></p-inputNumber>
                                            </div>
                                        </div>
        
                                        <hr>
                                    </div>
        
                                    <div *ngIf="a.mode == 'COMPLEX'
                                        && a.optional && a.selectionmode == ''"  class="PackageSelectLabel" style="margin-bottom: 8px;">
                                        <div style="margin-bottom:10px;" *ngIf="!a.optional"><b>Please select one of these {{a.name}}:</b></div>
                                        <div style="margin-bottom:10px;" *ngIf="a.optional">
                                            <div style="width:55px; float:left;"><p-inputSwitch [(ngModel)]="OptionalResources[a.orderindex]"></p-inputSwitch></div>
                                            <div *ngIf="!a.isconstructed == true" style="width:400px;float:left"><b>Would you like a {{a.name}}?</b></div>
                                            <div *ngIf="a.isconstructed == true" style="width:400px;float:left"><b>Would you like to choose a {{a.name}}?</b></div>
                                            <div style="clear:both;"></div>
                                        </div>

                                        <div *ngIf="OptionalResources[a.orderindex] && a.quantityselector == 'CUSTOM'" Style="margin-left:10px;">
                                            <div class="PackageSelectLabel" style="margin-bottom: 8px;">
                                                How many of the above resource would you like?
                                            </div>
                                            <div class="packageSelect" style="max-width: 500px; margin-bottom:20px;">
                                            <p-inputNumber [(ngModel)]="a.quantity" [showButtons]="true" max="100" min="1" buttonLayout="horizontal" spinnerMode="horizontal" (onInput)="donePartyRooms()"></p-inputNumber>
                                            </div>
                                        </div>

                                        <hr>
                                    </div>

                                    <div *ngIf="allowResourcesChangedManually && a.mode == 'COMPLEX' && (a.selectionmode == 'SYSTEMANY' || a.selectionmode == 'SYSTEMLIST')" class="PackageSelectLabel" style="margin-bottom: 8px;">
                                        <div style="margin-bottom:10px;"><b>{{a.name}}</b></div>
                                        <div style="margin-bottom: 5px; max-width:400px;" class="packageSelection clr" *ngFor="let r of (a.selectableresources)">
                                            <p-toggleButton style="width: 22rem; display: block;" [(ngModel)]="r.ignore"
                                                onLabel="{{r.name}}" offLabel="{{r.name}}"
                                                onIcon="pi pi-check-circle" offIcon="pi pi-circle"
                                                (onChange)="toggleButton(a,r)">
                                            </p-toggleButton>
                                        </div>
                                        <hr>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style="margin-top:20px">
                        <div *ngIf="startTimesFiltered">
                            <div *ngIf="!disgnosticsMode">    
                                <div *ngFor="let st of (startTimesFiltered)" class="times">
                                    <button pButton type="button" style="height: 50px;margin-top: 20px;font-size: 19px;" class="p-button p-button" (click)="bookSlot(st, false)">
                                        <span class="pi pi-clock" style="margin-right:8px;"></span>
                                        <span>{{ st.time | date:'HH:mm' : 'UTC' }}</span>            
                                    </button>
                            
                                </div>
                            </div>
                
                            <div *ngIf="disgnosticsMode">  
                                <div *ngFor="let st of (startTimes)">
                                    <div style="width:100%; margin-bottom: 10px;">
                                    
                                        <div *ngIf='st.primaryResource == true && st.timeAvailable == true'>
                                            <div style="float:left;">
                                                <div>
                                                    <button  pButton type="button" style="height: 50px;margin-top: 20px;font-size: 19px;" class="p-button p-button" (click)="bookSlot(st)">
                                                        <span class="pi pi-clock" style="margin-right:8px;"></span>
                                                        <span>{{ st.time | date:'HH:mm'  : 'UTC'}}</span>            
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                
                                        <div *ngIf='st.primaryResource == true && st.timeAvailable == false' style="width:100%;">
                                            <div style="float:left;">
                                                <!--<p-button class="p-button" label="Click" disabled="true" icon="pi pi-clock" iconPos="left" label="{{ st.time | date:'HH:mm' }}">
                                                </p-button>-->
                                                <div>
                                                    <button pButton type="button" disabled="true" style="height: 50px;margin-top: 20px;font-size: 19px;" class="p-button p-button" (click)="bookSlot(st)">
                                                        <span class="pi pi-clock" style="margin-right:8px;"></span>
                                                        <span>{{ st.time | date:'HH:mm'  : 'UTC'}}</span>            
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                
                                        <div  *ngIf='st.primaryResource == true' style="font-size: 17px;margin-top: 25px;width: 200px;float: left;margin-left: 20px;">Quantity Remaining: {{ st.quantityRemaining }}</div>
                                        
                                        <div *ngIf='st.primaryResource == true && st.reason != ""' style="font-size: 17px;margin-top: 15px;width: 400px;float: left;margin-left: 20px;background-color: pink;padding:10px;border-radius:40px;text-align:center;">Reason: {{ st.reason }}</div>
                                        <div *ngIf='st.primaryResource == true && st.reason == ""' style="font-size: 17px;margin-top: 15px;width: 400px;float: left;margin-left: 20px;background-color: #91ff91;padding:10px;border-radius:40px;text-align:center;">No issues found</div>
                                    
                                    </div>
                                    <div style="clear:both;"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <button *ngIf="ShowCheckButton && !ShowSaveButton" pButton type="button" style="height: 50px; margin-bottom:30px;" (click)="checkchanges(NewBooking)">
                        <span class="pi pi-search" style="margin-right:8px;"></span>
                        <span>Check availability for these settings</span>            
                    </button>

                    <button *ngIf="!ShowCheckButton && !paymentLinkExpired" pButton type="button" style="height: 50px;width: 22rem; margin-bottom:30px;" (click)="checkMoreTimes()">
                        <span class="pi pi-clock" style="margin-right:8px;"></span>
                        <span>Change Time</span>
                    </button>

                    <button *ngIf="ShowSaveButton" pButton type="button" style="height: 50px;margin-top: -60px; margin-bottom:30px;" (click)="bookExistingSlotTime(NewBooking.startTime)">
                        <span class="pi pi-check" style="margin-right:8px;"></span>
                        <span>Save these details for this Booking</span>
                    </button>
                    <hr style="margin-top: 0;">
                    <div>
                        <div class="field mb-4 col-12">
                            <label for="" class="font-medium">Send this email to this booking: </label><br>

                            <div *ngIf="ShowDynamicTextEditor" style="clear:both; padding-top:10px;">
                                <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">

                                    <h5>Email Preview</h5>

                                    <div style="overflow-x: hidden; max-height: 40vh; overflow-y: auto; border: 1px solid #e5e7eb; padding: 10px;">
                                        <div [innerHTML]="ExampleEmail | safe: 'html'"></div>
                                    </div>

                                    <div class="field mb-4 col-12" style="margin-top:15px;">
                                        <p>{{DynamicContentButton}}</p>
                                    </div>

                                    <div *ngFor="let c of dynamicTextArray" class="field mb-4 col-12" style="margin-top: -20px; width:100%;">
                                        <label for="dynamictext{{c.index}}" class="font-medium">Dynamic Text {{c.index + 1}}</label>
                                        <br>
                                        <textarea pInputText id="dynamictext{{c.index}}" [(ngModel)]="c.text" style="width:100%"></textarea>
                                    </div>

                                    <p-button icon="pi pi-check" label="Update Preview" styleClass="p-button p-button-success" (click)="SaveText()"></p-button>
                                    &nbsp;
                                    <p-button icon="pi pi-times" label="Clear" styleClass="p-button p-button-danger" (click)="CancelText()"></p-button>
                                    <div style="clear:both;"></div>
                                </div>
                            </div>

                            <p-dropdown [options]="EmailTemplates" [style]="{'width': '300px', 'float': 'left'}"  placeholder="Select a template" [showClear]="true" [(ngModel)]="selectedEmailTemplate" optionLabel="name" (onChange)="changeTemplate()"></p-dropdown>
                        </div>
                        <div style="width: 100px; float: left; margin-top: -32px; margin-left: 10px;">
                            <p-button icon="pi pi-send" label="Send" styleClass="p-button p-button-success" (click)="sendEmailToBooking()"></p-button>
                        </div>
                    </div>
                    <div *ngIf="!templateValid" class="text-danger" Style="clear:both; width:100%"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Template.</div>
                
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Customer">
                <ng-template pTemplate="header">
                    <i class="pi pi-user" style="margin-right: 5px;"></i>
                    <span>Customer</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <label for="ddlPackage" class="font-medium">Customer Name</label>
                    <div style="max-width: 1000px;margin-bottom: 36px;margin-top:12px;">
                        <div class="surface-card p-4 shadow-2 border-round">
        
                            <div class="grid formgrid p-fluid">
            
                                <div  *ngIf="NewBooking.customer != null" class="field mb-4 col-12">
                                    <p-selectButton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptions" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectButton>
                                </div>
            
                                <div style="width:100%;margin-bottom:15px;" *ngIf="NewBooking.customer == null">
                                    <div>There is no customer on this booking!</div>
                                </div>
                                <div *ngIf="NewBooking.customer != null">
                                    <div class="field mb-4 col-12" >
                                        <label for="firstName" class="font-medium">First Name</label>
                                        <input id="firstName" type="text" [(ngModel)]="NewBooking.customer.firstName" pInputText autocomplete="given-name">
                                    </div>
                                    <div *ngIf="!firstNameEditValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a first name.</div>
                                    
                                    <div class="field mb-4 col-12">
                                        <label for="lastname" class="font-medium">Last Name</label>
                                        <input id="lastname" type="text" [(ngModel)]="NewBooking.customer.lastName" pInputText autocomplete="family-name">
                                    </div>
                                    <div *ngIf="!lastNameEditValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>
                
                                    <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                        <label for="address1" class="font-medium">Address 1</label>
                                        <input id="address1" type="text" [(ngModel)]="NewBooking.customer.address1" pInputText autocomplete="address-line1">
                                    </div>
                                    <div *ngIf="!Address1EditValid && !ProvideMinimalPersonalData" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an address.</div>
                
                                    <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                        <label for="address2" class="font-medium">Address 2</label>
                                        <input id="address2" type="text" [(ngModel)]="NewBooking.customer.address2" pInputText autocomplete="address-line2">
                                    </div>
                                
                                    <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                        <label for="town" class="font-medium">Town / City</label>
                                        <input id="town" type="text" [(ngModel)]="NewBooking.customer.townCity" pInputText autocomplete="address-line3">
                                    </div>
                                    <div *ngIf="!TownEditValid && !ProvideMinimalPersonalData" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a town/city.</div>
                
                                    <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                        <label for="postcode" class="font-medium">Post Code</label>
                                        <input id="postcode" type="text" [(ngModel)]="NewBooking.customer.postCode" pInputText autocomplete="postal-code">
                                    </div>
                                    <div *ngIf="!PostCodeEditValid && !ProvideMinimalPersonalData" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a postcode.</div>
                
                                    <div class="field mb-4 col-12">
                                        <label for="email" class="font-medium">Email</label>
                                        <input id="email" type="email" [(ngModel)]="NewBooking.customer.email" pInputText autocomplete="email">
                                    </div>
                                    <div *ngIf="!EmailEditValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                                    <div *ngIf="!EmailFormatEditValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>
                
                                    <div class="field mb-4 col-12">
                                        <label for="mobile" class="font-medium">Mobile</label>
                                        <input id="mobile" type="tel" [(ngModel)]="NewBooking.customer.mobile" pInputText autocomplete="mobile">
                                    </div>
                                    <div *ngIf="!MobileEditValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a mobile number.</div>
                                    <div *ngIf="!MobileFormatEditValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid mobile number.<div style="clear:both;"></div></div>
                
                                    <div style="clear:both;width: 100%;height: 20px;"></div>
                                    <button pButton type="button" style="height: 50px; width: 200px;margin-top:0px" class="p-button p-button" (click)="updateCustomer()">
                                        <span class="pi pi-save" style="margin-right:8px;"></span>
                                        <span>Save Customer</span>
                                    </button>
                                    &nbsp;
                                </div>
                                <div *ngIf="!ShowCustomerSearch" style="width:100%; margin-top:15px;">
                                    <button pButton type="button" style="width: 250px;height: 50px;font-size: 16px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="showCustomerSearch()">
                                        <span class="pi pi-search" style="margin-right:8px;"></span>
                                        <span>Search for a Customer</span>
                                    </button>
                                </div>
            
                            </div>
                        </div>

                    </div>

                    <div *ngIf="ShowCustomerSearch" style="margin-bottom: 40px;">
                        <span class="p-input-icon-left ml-auto" style="margin-right:20px; float:left;"> 
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" [(ngModel)]="searchCriteria" buttonLayout="horizontal" style="height: 50px;padding-left:33px;" />
                        </span>
                        
                        <button pButton type="button" style="float:left;height: 50px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="searchCustomer()">
                        <span class="pi pi-search" style="margin-right:8px;"></span>
                        <span i18>Search</span>
                        </button>
                        <p style="float: left;width: 376px;font-size: 15px;color: #ccc;margin-top: 10px;margin-left: 10px;">(Lastname/Mobile Number/Post Code)</p>
                        <div style="clear:both;"></div>
                        <div style="margin-top:20px;" class="surface-card p-4 shadow-2 border-round" *ngIf="customersResult">
                        <p-table [value]="customersResult.data">
                        <ng-template pTemplate="header">
                            <tr style="color:Black;background-color:White;font-weight:bold;">
                            <th scope="col">Name</th>
                            <th scope="col">Address</th>
                            <th scope="col">Mobile</th>
                            <th scope="col">Post Code</th>
                            <th width="5%">&nbsp;</th>
                            <th width="5%">&nbsp;</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data>
                            <tr onmouseover="this.originalstyle=this.style.backgroundColor;this.style.backgroundColor='#dddddd'" onmouseout="this.style.backgroundColor=this.originalstyle;" style="background-color: rgb(255, 255, 255); cursor: pointer;">
                                <td (click)="addselectedCustomer(data)">{{data.fullName}}</td>
                                <td>{{data.address1}}</td>
                                <td>{{data.mobile}}</td>
                                <td>{{data.postCode}}</td>
                                <td>
                                    <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="addselectedCustomer(data)">
                                    <span class="pi pi-check" style="margin-right:8px;"></span>
                                    Select</button>
                                </td>
                                <td>
                                    <button pButton pRipple type="button" class="p-button p-element p-button-success" (click)="applyCustomer(data)">
                                    <span class="pi pi-pencil" style="margin-right:8px;"></span>
                                    Edit</button>
                                </td>
                            </tr>  
                        </ng-template>  
                        </p-table>
                        <button *ngIf="customersResult" style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="addCustomer(data)">
                            <span class="pi pi-pencil" style="margin-right:8px;"></span>
                            Add Customer</button>
                        </div>
                    </div>
        
                    <div *ngIf="ShowCustomerDetails" class="surface-card p-4 shadow-2 border-round">
        
                        <div class="grid formgrid p-fluid">
        
                            <div class="field mb-4 col-12">
                                <p-selectButton id="exclusive" [style]="{'width': '100%', 'max-width' : '600px'}" [options]="stateOptions" [(ngModel)]="ProvideMinimalPersonalData" ></p-selectButton>
                            </div>
    
                            <div class="field mb-4 col-12" >
                                <label for="firstName" class="font-medium">First Name</label>
                                <input id="firstName" type="text" [(ngModel)]="firstName" pInputText autocomplete="given-name">
                            </div>
                            <div *ngIf="!firstNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a first name.</div>
                        
                            <div class="field mb-4 col-12">
                                <label for="lastname" class="font-medium">Last Name</label>
                                <input id="lastname" type="text" [(ngModel)]="lastName" pInputText autocomplete="family-name">
                            </div>
                            <div *ngIf="!lastNameValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a last name.</div>
        
                            <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                <label for="address1" class="font-medium">Address 1</label>
                                <input id="address1" type="text" [(ngModel)]="address1" pInputText autocomplete="address-line1">
                            </div>
                            <div *ngIf="!Address1Valid && !ProvideMinimalPersonalData" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an address.</div>
        
                            <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                <label for="address2" class="font-medium">Address 2</label>
                                <input id="address2" type="text" [(ngModel)]="address2" pInputText autocomplete="address-line2">
                            </div>
                        
                            <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                <label for="town" class="font-medium">Town / City</label>
                                <input id="town" type="text" [(ngModel)]="town" pInputText autocomplete="address-line3">
                            </div>
                            <div *ngIf="!TownValid && !ProvideMinimalPersonalData" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a town/city.</div>
        
                            <div class="field mb-4 col-12" *ngIf="!ProvideMinimalPersonalData">
                                <label for="postcode" class="font-medium">Post Code</label>
                                <input id="postcode" type="text" [(ngModel)]="postCode" pInputText autocomplete="postal-code">
                            </div>
                            <div *ngIf="!PostCodeValid && !ProvideMinimalPersonalData" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a postcode.</div>
        
                            <div class="field mb-4 col-12">
                                <label for="email" class="font-medium">Email</label>
                                <input id="email" type="email" [(ngModel)]="email" pInputText autocomplete="email">
                            </div>
                            <div *ngIf="!EmailValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an email address.</div>
                            <div *ngIf="!EmailFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid email address.</div>
        
                            <div class="field mb-4 col-12">
                                <label for="mobile" class="font-medium">Mobile</label>
                                <input id="mobile" type="tel" [(ngModel)]="mobile" pInputText autocomplete="mobile">
                            </div>
                            <div *ngIf="!MobileValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a mobile number.</div>
                            <div *ngIf="!MobileFormatValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a valid mobile number.<div style="clear:both;"></div></div>
        
                            <div style="clear:both;width: 100%;height: 20px;"></div>
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneCustomer()">
                                <span>Add this Customer</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>
        
                        </div>
                    </div>
        
                    <button *ngIf="CustomerHasBeenEdited" style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="saveCustomer()">
                        <span class="pi pi-check" style="margin-right:8px;"></span>
                        Save Customer
                    </button>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Upgrades">
                <ng-template pTemplate="header">
                    <i class="pi pi-arrow-up" style="margin-right: 5px;"></i>
                    <span>Upgrades</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <!-- <div *ngIf="availablePackageUpgrades != null || availablePackageUpgrades.length > 0">
                        
                    </div> -->
                    
                    <!-- dataKey so the selected upgrade is matched on its id rather than on being
                         the very same object as the one in the list. -->
                    <p-dropdown [style]="{'width': '300px'}" [options]="availablePackageUpgrades" [(ngModel)]="CurrentUpgrade" placeholder="Select an Upgrade" [showClear]="true" optionLabel="name" dataKey="packageupgradeid"></p-dropdown>

                    <div *ngIf="!availablePackageUpgrades">
                        There are currently no upgrades on this booking
                    </div>

                    <div style="clear:both;"></div>
                    <button style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="saveUpgradess()">
                        <span class="pi pi-pencil" style="margin-right:8px;"></span>
                        Save Upgrades</button>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Extras">
                <ng-template pTemplate="header">
                    <i class="pi pi-star" style="margin-right: 5px;"></i>
                    <span>Extras</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div *ngIf="packageExtras != null">
                        <p-table [value]="packageExtras" style="width:100%">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:70%">Extra</th>
                                <th style="width:10%">Price</th>
                                <th style="width:10%">Quantity</th>
                                <th style="width:10%">Cost</th>
                            </tr>
                        </ng-template>
                            <ng-template pTemplate="body" let-product let-index>
                                <tr>
                                    <td>{{product.name}}</td>
                                    <td>{{product.price | currency:CurrencySymbol}}</td>
                                    <td><p-inputNumber [(ngModel)]="product.qty" [disabled]="ExtraEnabled" [showButtons]="true" max="{{product.max}}" min="{{product.min}}" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber></td>
                                    <td [align]="right">{{(product.qty * product.price) | currency:CurrencySymbol}}</td>
                                </tr>
                                <tr style="border:none;" *ngIf="(product.question!='' && product.question != null) && product.qty > 0">
                                    <td style="border:none;" colspan="4">
                                        {{product.question}}
                                    </td>
                                </tr>
                                <tr style="border:none;" *ngIf="(product.question!='' && product.question != null) && product.qty > 0">
                                    <td style="border-top:none;" colspan="4">
                                        <input style="width: 100%" type="text" [(ngModel)]="product.answer" pInputText>
                                    </td>
                                </tr>
                            </ng-template>
        
                        </p-table>
                    </div>
                    <div *ngIf="packageExtras == null">
                        There are no extras for this booking.

                        <div class="col-12">
                            <p-table [value]="packageExtrasNew">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:70%">Extra</th>
                                    <th style="width:10%">Price</th>
                                    <th style="width:10%">Quantity</th>
                                    <th style="width:10%">Cost</th>
                                </tr>
                            </ng-template>
                                <ng-template pTemplate="body" let-product let-index>
                                    <tr>
                                        <td>{{product.name}}</td>
                                        <td>{{product.price | currency:CurrencySymbol}}</td>
                                        <td><p-inputNumber [(ngModel)]="product.qty" [disabled]="ExtraEnabled" [showButtons]="true" max="{{product.max}}" min="{{product.min}}" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputNumber></td>
                                        <td>{{(product.qty * product.price) | currency:CurrencySymbol}}</td>
                                    </tr>
                                </ng-template>
                                </p-table>
                        </div>

                    </div>

                    <div *ngIf="!allQuestionsValid" class="text-danger" Style="margin-left:10px; margin-top: 15px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer all questions.</div>
                    

                    <button style="margin-top:15px;" pButton pRipple type="button" class="p-button p-element p-button-success" (click)="saveExtras()">
                        <span class="pi pi-pencil" style="margin-right:8px;"></span>
                        Save Extras</button>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Booking Questions">
                <ng-template pTemplate="header">
                    <i class="pi pi-question-circle" style="margin-right: 5px;"></i>
                    <span>Questions</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">
                        <div *ngIf="NewBooking.questionnaire== null">
                            There are no booking questions for this booking.
                        </div>

                        <div *ngIf="NewBooking.questionnaire!= null" class="surface-card p-4 shadow-2 border-round">
                            <div class="grid formgrid p-fluid">
                                <div *ngFor="let bq of NewBooking.questionnaire.bookingquestions" class="field mb-4 col-12">
                                    <div *ngIf="bq.questiontype=='FREETEXT'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.freetextanswer" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerfreetext[bq.listorder]}">
                                        <div *ngIf="!mustanswerfreetext[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must this question.</div>
                                    </div>
                                    
                                    <div *ngIf="bq.questiontype=='BIRTHDAY'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>

                                        <!-- One card per person, so where one person's details end and the next begin
                                             reads at a glance. The fields sit on a row that wraps as a whole rather
                                             than in floated percentage columns, which is what left the year and the
                                             gender buttons stranded on lines of their own. -->
                                        <div class="bqperson" *ngFor="let ibq of bq.answers.birthdayanswers; let pi = index">
                                            <div class="bqperson-head">
                                                <span class="bqperson-title">{{ibq.name != null && ibq.name != '' ? ibq.name : 'Person ' + (pi + 1)}}</span>
                                                <button *ngIf="bq.answers.birthdayanswers.length > 1 && !bq.linkedtoparticipants" pButton type="button" class="p-button-danger p-button-text p-button-sm bqperson-delete" (click)="deleteBirthdayRow(bq, ibq.id)">
                                                    <span class="pi pi-trash" style="margin-right:6px;"></span>
                                                    <span>Delete</span>
                                                </button>
                                            </div>

                                            <div class="bqfields">
                                                <div class="bqfield bqfield--name">
                                                    <label class="bqlabel" for="bqname{{bq.id}}_{{ibq.id}}">Name</label>
                                                    <input id="bqname{{bq.id}}_{{ibq.id}}" type="text" placeholder="Name" [(ngModel)]="ibq.name" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.name == '' || ibq.name == null)}">
                                                </div>

                                                <div class="bqfield bqfield--age" *ngIf="bq.showage">
                                                    <label class="bqlabel">Age</label>
                                                    <p-dropdown [options]="ageOptionsFor(bq)" [(ngModel)]="ibq.age" placeholder="Select age" optionLabel="name" optionValue="value" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.age == '' || ibq.age == null)}"></p-dropdown>
                                                </div>

                                                <div class="bqfield bqfield--dob" *ngIf="bq.showdob">
                                                    <label class="bqlabel">Date of Birth</label>
                                                    <div class="bqdob">
                                                        <p-dropdown class="bqdob-day" optionLabel="name" optionValue="value" [options]="caldays" [(ngModel)]="ibq.dobday" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                                        <span class="bqdob-sep">/</span>
                                                        <p-dropdown class="bqdob-month" optionLabel="name" optionValue="value" [options]="calmonths" [(ngModel)]="ibq.dobmonth" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                                        <span class="bqdob-sep">/</span>
                                                        <p-dropdown class="bqdob-year" optionLabel="name" optionValue="value" [options]="calyears" [(ngModel)]="ibq.dobyear" placeholder="----" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                                    </div>
                                                </div>

                                                <div class="bqfield bqfield--gender" *ngIf="bq.showgender">
                                                    <label class="bqlabel">Gender</label>
                                                    <p-selectButton id="bqgender{{bq.id}}_{{ibq.id}}" [options]="stateGenderOptions" [(ngModel)]="ibq.gender"></p-selectButton>
                                                </div>

                                                <div class="bqfield bqfield--interests" *ngIf="bq.showinterests">
                                                    <label class="bqlabel" for="bqint{{bq.id}}_{{ibq.id}}">Interests</label>
                                                    <input id="bqint{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.interests" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.interests == '' || ibq.interests == null)}">
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="!bq.linkedtoparticipants">
                                            <button pButton type="button" class="p-button bqaddanother" (click)="addBirthdayRow(bq)">
                                                <span>Add another</span>
                                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="!mustanswerbirthdays[bq.listorder]" class="text-danger" Style="margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide all details.</div>
                                    </div>

                                    <div *ngIf="bq.questiontype=='REGISTER' && bq.answers != null">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>

                                        <!-- A register is the list of people on the booking. The name is always asked for; the rest
                                             of the fields are whichever ones the question was set up to include, and the last one
                                             carries the venue's own wording. -->
                                        <div class="bqperson" *ngFor="let ibq of bq.answers.birthdayanswers; let pi = index">
                                            <div class="bqperson-head">
                                                <span class="bqperson-title">{{ibq.name != null && ibq.name != '' ? ibq.name : 'Person ' + (pi + 1)}}</span>
                                                <button *ngIf="bq.answers.birthdayanswers.length > 1 && !bq.linkedtoparticipants" pButton type="button" class="p-button-danger p-button-text p-button-sm bqperson-delete" (click)="deleteBirthdayRow(bq, ibq.id)">
                                                    <span class="pi pi-trash" style="margin-right:6px;"></span>
                                                    <span>Delete</span>
                                                </button>
                                            </div>

                                            <div class="bqfields">
                                                <div class="bqfield bqfield--name">
                                                    <label class="bqlabel" for="bqrname{{bq.id}}_{{ibq.id}}">Name</label>
                                                    <input id="bqrname{{bq.id}}_{{ibq.id}}" type="text" placeholder="Name" [(ngModel)]="ibq.name" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.name == '' || ibq.name == null)}">
                                                </div>

                                                <div class="bqfield bqfield--age" *ngIf="bq.showage">
                                                    <label class="bqlabel">Age</label>
                                                    <p-dropdown [options]="ageOptionsFor(bq)" [(ngModel)]="ibq.age" placeholder="Select age" optionLabel="name" optionValue="value" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.age == '' || ibq.age == null)}"></p-dropdown>
                                                </div>

                                                <div class="bqfield bqfield--dob" *ngIf="bq.showdob">
                                                    <label class="bqlabel">Date of Birth</label>
                                                    <div class="bqdob">
                                                        <p-dropdown class="bqdob-day" optionLabel="name" optionValue="value" [options]="caldays" [(ngModel)]="ibq.dobday" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                                        <span class="bqdob-sep">/</span>
                                                        <p-dropdown class="bqdob-month" optionLabel="name" optionValue="value" [options]="calmonths" [(ngModel)]="ibq.dobmonth" placeholder="--" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                                        <span class="bqdob-sep">/</span>
                                                        <p-dropdown class="bqdob-year" optionLabel="name" optionValue="value" [options]="calyears" [(ngModel)]="ibq.dobyear" placeholder="----" [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.dobday == null || ibq.dobmonth == null || ibq.dobyear == null)}"></p-dropdown>
                                                    </div>
                                                </div>

                                                <div class="bqfield bqfield--interests" *ngIf="bq.showinterests">
                                                    <label class="bqlabel" for="bqrextra{{bq.id}}_{{ibq.id}}">{{bq.warningtext}}</label>
                                                    <input id="bqrextra{{bq.id}}_{{ibq.id}}" type="text" [(ngModel)]="ibq.interests" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerbirthdays[bq.listorder] && (ibq.interests == '' || ibq.interests == null)}">
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="!bq.linkedtoparticipants">
                                            <button pButton type="button" class="p-button bqaddanother" (click)="addBirthdayRow(bq)">
                                                <span>Add another</span>
                                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                            </button>
                                        </div>
                                        <div *ngIf="!mustanswerbirthdays[bq.listorder]" class="text-danger" style="margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide all details.</div>
                                    </div>

                                    <div *ngIf="bq.questiontype=='AGE' && bq.answers != null">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <p-inputNumber [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" min="{{bq.minage}}" max="{{bq.maxage}}" spinnerMode="horizontal" [ngClass]="{'ng-invalid ng-dirty': !mustanswerage[bq.listorder]}"></p-inputNumber>
                                        <div *ngIf="!mustanswerage[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide age details.</div>
                                    </div>
                                    
                                    <div *ngIf="bq.questiontype=='ALLERGY'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <p-selectButton id="allergy" [style]="{'width': '100%', 'max-width' : '230px'}" [options]="stateOptionAllergy" [(ngModel)]="bq.answers.allergyanswer.allergypresent"></p-selectButton>
                                        <div *ngIf="bq.answers.allergyanswer.allergypresent==true">
                                            <label for="bq{{bq.id}}" style="margin-top:20px;" class="font-medium">Please specify any allergy details below</label>
                                            <input id="bq{{bq.id}}" type="text" [(ngModel)]="bq.answers.allergyanswer.allergytext" pInputText [ngClass]="{'ng-invalid ng-dirty': !mustanswerallergies[bq.listorder]}">
                                        </div>
                                        <div *ngIf="!mustanswerallergies[bq.listorder] && bq.answers.allergyanswer.allergypresent==true" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must provide allergy details.</div>
                                    </div>
                                    
                                    <div *ngIf="bq.questiontype=='MULTICHOICESINGLE'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <div>
                                            <p-dropdown [options]="bq.listitems" placeholder="Please select an option" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicesingleanswer" [ngClass]="{'ng-invalid ng-dirty': !mustanswermultichoicesingleanswer[bq.listorder]}"></p-dropdown>
                                        </div>
                                        <div *ngIf="!mustanswermultichoicesingleanswer[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose an item.</div>
                                    </div>
                                    
                                    <div *ngIf="bq.questiontype=='MULTICHOICEMULTIPLE'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <div>
                                            <p-multiSelect [options]="bq.listitems" placeholder="Please select one or more options" optionLabel="listitemtext" [(ngModel)]="bq.answers.multichoicemultianswer" [ngClass]="{'ng-invalid ng-dirty': !mustanswermultichoicemultianswer[bq.listorder]}"></p-multiSelect>
                                        </div>
                                        <div *ngIf="!mustanswermultichoicemultianswer[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and choose one or more items.</div>
                                    </div>
                                    
                                    <div *ngIf="bq.questiontype=='DATE'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <p-calendar [selectOtherMonths]="true" firstDayOfWeek="1" [(ngModel)]="dateAnswer[bq.listorder]" dateFormat="dd/mm/yy" [showIcon]="true" [ngClass]="{'ng-invalid ng-dirty': !mustanswerdate[bq.listorder]}"></p-calendar>
                                        <div *ngIf="!mustanswerdate[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a date.</div>
                                    </div>
                                    
                                    <div *ngIf="bq.questiontype=='NUMBER'">
                                        <label for="bq{{bq.id}}" class="font-medium">{{bq.questiontext}}</label>
                                        <p-inputNumber [showButtons]="true" buttonLayout="horizontal" [(ngModel)]="bq.answers.numberanswer" spinnerMode="horizontal" [ngClass]="{'ng-invalid ng-dirty': !mustanswernumber[bq.listorder]}"></p-inputNumber>
                                        <div *ngIf="!mustanswernumber[bq.listorder]" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must answer this question and supply a number.</div>
                                    </div>
                                    <hr style="margin-bottom:0px;margin-top:20px">
                                </div>
                            </div>
            
                            <div style="clear:both;">
                                <button pButton type="button" style="height: 50px; width: 155px;margin-top:20px;" class="p-button p-button" (click)="saveBookingQuestions()">
                                    <span>Next</span>
                                    <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                                </button> &nbsp;
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-tabPanel>

            <!-- A series is paid as a whole, on Edit Series, never one date at a time. -->
            <p-tabPanel header="Payments" *ngIf="!seriesLocked">
                <ng-template pTemplate="header">
                    <i class="pi pi-pound" style="margin-right: 5px;"></i>
                    <span>Payments</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div class="surface-card p-4 shadow-2 border-round">
                        <label for="refunds" class="font-medium">Payments already made</label>   
                        <div *ngIf="NewBooking.payments != null">
                            <p-table [value]="NewBooking.payments">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th style="width:1%"></th>
                                        <th style="width:1%"></th>
                                        <th style="width:30%">Date</th>
                                        <th style="width:30%">User</th>
                                        <th style="width:7%">Method</th>
                                        <th style="width:7%">Reason</th>
                                        <th style="width:5%">Amount</th>
                                        <th style="width:5%">Balance</th>
                                        <th style="width:9%">&nbsp;</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-payment let-index>
                                    <tr *ngIf="payment.amount > 0">
                                        <td><img alt="Payment" src="https://dev.wannabook.online/assets/images/paymentin.png" style="width: 25px; height: 25px;"/></td> 
                                        <!-- <td><img alt="Info" src="https://dev.wannabook.online/assets/images/info.png" style="width: 25px; height: 25px;" (click)="op.toggle($event)" /></td> 
                                         -->

                                         <td><img alt="Info" src="https://dev.wannabook.online/assets/images/info.png" style="width: 25px; height: 25px;" (click)="opMoreInfo.toggle($event)" />
                                            <p-overlayPanel #opMoreInfo>
                                                <div class="flex flex-column gap-3 w-25rem">
                                                    <div>
                                                        <span class="font-medium text-900 block mb-2" style="font-size:25px;">Payment Informtation</span>
                                                        <span style="font-weight:bold; width:155px;float:left;">Payment Date:</span><span style="float:left;">{{payment.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</span><br>
                                                        <span style="font-weight:bold; width:155px;float:left;">Username:</span><span style="float:left;">{{payment.username}}</span><br>
                                                        <span style="font-weight:bold; width:155px;float:left;">Payment Method:</span><span style="float:left;">{{payment.method}}</span><br>
                                                        <span style="font-weight:bold; width:155px;float:left;">Reason for Refund:</span><span style="float:left;">{{payment.refundreason}}</span><br>
                                                        <span style="font-weight:bold; width:155px;float:left;">Payment ID:</span><span style="float:left;">{{payment.intent}}</span><br>
                                                        <span style="font-weight:bold; width:155px;float:left;">Amount:</span><span style="float:left;">{{(payment.amount) | currency:CurrencySymbol}}</span><br>
                                                        <span style="font-weight:bold; width:155px;float:left;">Balance:</span><span style="float:left;">{{(payment.balance) | currency:CurrencySymbol}}</span><br>
                                                    </div>
                                                </div>
                                            </p-overlayPanel>
                                        </td> 
                                        <td>{{payment.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                        <td>{{payment.username}}</td>
                                        <td>{{payment.method}}</td>
                                        <td>{{payment.refundreason}}</td>
                                        <td>{{(payment.amount) | currency:CurrencySymbol}}</td>
                                        <td>{{(payment.balance) | currency:CurrencySymbol}}</td>
                                        <td *ngIf="payment.balance > 0">
                                            <button pButton type="button" style="height: 36px; width: 100px;margin-top:0px" class="p-button p-button p-button-danger" (click)="setupRefund(payment.paymentId)">
                                                <span>Refund</span>
                                            </button>
                                        </td>

                                        <td *ngIf="payment.balance <= 0">
                                            <button pButton type="button" style="height: 36px; width: 100px;margin-top:0px; border-color: #cccccc; background-color: #cccccc !important;" [disabled]="true" class="p-button p-button">
                                                <span>Refund</span>
                                            </button>
                                        </td>
                                    </tr>

                                    <tr *ngIf="payment.amount <= 0">
                                        <td><img alt="Refund"  src="https://dev.wannabook.online/assets/images/paymentout.png" style="width: 25px; height: 25px;"/></td>
                                        <td><img alt="Info" src="https://dev.wannabook.online/assets/images/info.png" style="width: 25px; height: 25px;"/></td> 
                                        
                                        <td style="color:red;" >{{payment.paymentDate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                        <td style="color:red;" >{{payment.username}}</td>
                                        <td style="color:red;" >{{payment.method}}</td>
                                        <td style="color:red;" >{{payment.refundreason}}</td>
                                        <td style="color:red;" >{{(payment.amount) | currency:CurrencySymbol}}</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                        <div *ngIf="NewBooking.payments == null">
                            No payments have been made against this booking
                        </div>
                        <div *ngIf="NewBooking.discounts != null">
                            <br>
                            <label for="refunds" class="font-medium">Discounts applied</label>   

                            <p-table [value]="NewBooking.discounts">
                                <ng-template pTemplate="header">
                                    <tr>
                                        <th></th>
                                        <th style="width:35%">Date</th>
                                        <th style="width:30%">User</th>
                                        <th style="width:20%">Discount Name</th>
                                        <th style="width:10%">Amount</th>
                                        <th style="width:5%">&nbsp;</th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-discount let-index>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td>{{discount.discountdate | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                        <td>{{discount.username}}</td>
                                        <td>{{discount.name}}</td>
                                        <td>{{(discount.totaldiscount) | currency:CurrencySymbol}}</td>
                                        <td>
                                            <button pButton type="button" style="height: 36px; width: 100px;margin-top:0px" class="p-button p-button p-button-danger" (click)="removeDiscount()">
                                                <span>Remove</span>
                                            </button>
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                    <br>
                    <!-- <div *ngIf="NewBooking.outstanding == 0 && NewBooking.discounts" class="surface-card p-4 shadow-2 border-round">
                        <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button-success" (click)="removeDiscount()">
                            <span>Remove Discount</span>
                            <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                        </button>
                    </div> -->
                    <div *ngIf="NewBooking.outstanding != 0" class="surface-card p-4 shadow-2 border-round">
                        <div style="font-weight:bold; font-size:20px; margin-bottom:20px;">
                            Value of Booking: {{(NewBooking.totaladmissions) |  currency:CurrencySymbol}} 
                            <span *ngIf="NewBooking.totaldiscounts > 0">(- Discount: {{NewBooking.totaldiscounts | currency:CurrencySymbol}})</span>
                            <span *ngIf="NewBooking.totalbookingfees> 0"> + Booking Fee: {{NewBooking.totalbookingfees | currency:CurrencySymbol}}</span>
                            <span *ngIf="NewBooking.totalextras> 0"> + Extras Value: {{NewBooking.totalextras | currency:CurrencySymbol}}</span>
                            <span> (Total Value: {{(NewBooking.total) | currency:CurrencySymbol}})</span>
                        </div>

                        <div class="field mb-4 col-12">
                            <label for="venueclosingname" class="font-medium">Payment Value</label><br>
                            <p-inputNumber [(ngModel)]="validPaymentAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputNumber>
                        </div>

                        <div *ngIf="!paymentValueValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a payment amount.</div>
                        <div *ngIf="!paymentValueExceededValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You cannot pay more than the booking value.</div>
                        <div *ngIf="!paymentDepositValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>Your payment must be at least {{validPaymentAmount | currency:CurrencySymbol}}.</div>

                        <div class="field mb-4 col-12">
                            <label for="paymentType" class="font-medium">Payment Type</label><br>
                            <p-dropdown [options]="PaymentTypes" [(ngModel)]="selectedPayment" optionLabel="name" placeholder="Select a Type" [showClear]="true" (onChange)="resetlock()"></p-dropdown>
                        </div>
                        <div *ngIf="!paymentTypeValid" class="text-danger" Style="margin-left:10px; margin-top: -23px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a payment type.</div>

                        <div *ngIf="showDiscount" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">

                            <p-selectButton id="allergy" [style]="{'width': '100%', 'max-width' : '430px', 'margin-bottom' : '20px'}" [options]="stateOptionOpenDiscount" [(ngModel)]="openDiscount"></p-selectButton>

                            <div *ngIf="openDiscount" style="margin-bottom:30px;">
                                <label for="discountAmount" class="font-medium">Enter Discount Amount</label><br>
                                <p-inputNumber [(ngModel)]="chosenDiscountAmount" mode="currency" currency="{{CurrencySymbol}}" [min]="0" max="{{validPaymentAmount}}"></p-inputNumber>
                                <!-- <p-inputNumber [(ngModel)]="chosenDiscountAmount" mode="currency" currency="{{CurrencySymbol}}" locale="en-GB" [min]="0" [max]="9999"></p-inputNumber>-->
                            </div>

                            <div *ngIf="!openDiscount" class="field mb-4 col-12">
                                <label for="discountCode" class="font-medium">Enter Discount Code</label><br>
                                <input id="discountCode" [(ngModel)]="discountCode" pInputText>
                            </div>

                            <button *ngIf="openDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneOpenDiscount()">
                                <span>Apply Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>

                            <button *ngIf="!openDiscount" pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneDiscount()">
                                <span>Apply Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>
                        </div>

                        <div *ngIf="showVoucher" class="surface-card p-4 shadow-2 border-round" style="margin-bottom:20px;">
                            <div class="field mb-4 col-12" style="float:left;">
                                <label for="voucherCode" class="font-medium">Enter Gift Voucher</label><br>
                                <input id="voucherCode" [(ngModel)]="voucherCode" pInputText>
                                <br>
                                <label for="voucherPIN" class="font-medium">Enter PIN</label><br>
                                <input id="voucherPIN" [(ngModel)]="voucherpin" pInputText [maxlength]="4" type="password">
                                <div style="clear:both; width:100%"></div>
                            </div>
                            <div>
                                <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="doneVoucher()">
                                    <span>Apply</span>
                                </button>
                            </div>
                            <div style="clear:both; width:100%"></div>
                        </div> 

                        
                        <button pButton type="button" [disabled]="paymentButtonLocked" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button" (click)="makeNewPayment()">
                            <span>{{PaymentButton}}</span>
                            <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                        </button>
                        &nbsp;

                        <span *ngIf="!showDiscount">
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button-success" (click)="displayDiscount()">
                                <span>Enter Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>
                            &nbsp;
                        </span>

                        <span *ngIf="showDiscount">
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button-success" (click)="displayDiscount()">
                                <span>Hide Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>
                            &nbsp;
                        </span>

                        <span *ngIf="NewBooking.discounts" >
                            <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px" class="p-button p-button-success" (click)="removeDiscount()">
                                <span>Remove Discount</span>
                                <span class="pi pi-chevron-right" style="margin-left:8px;"></span>
                            </button>
                            &nbsp;
                        </span>

                        <button *ngIf="!showVoucher" pButton type="button" style="height: 50px; width: 221px;margin-right:15px;margin-top:15px;" class="p-button p-button-success" (click)="displayVoucher()">
                            <span class="pi pi-ticket" style="margin-right:8px;"></span>
                            <span>Enter Gift Voucher</span>
                        </button>
                        <button *ngIf="showVoucher" pButton type="button" style="height: 50px; width: 221px;margin-right:15px;margin-top:15px;" class="p-button p-button-success" (click)="displayVoucher()">
                            <span class="pi pi-ticket" style="margin-right:8px;"></span>
                            <span>Hide Gift Voucher</span>
                        </button>
                        <!-- <button pButton type="button" style="height: 50px; width: 221px;margin-top:0px;margin-right:15px;" class="p-button p-button-warning" (click)="sendPaymentLink()">
                            <span class="pi pi-envelope" style="margin-right:8px;"></span>
                            <span>Send Payment Link</span>
                        </button> -->
                    </div> 

                    
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Waivers" *ngIf="showWaiversTab">
                <ng-template pTemplate="header">
                    <i class="pi pi-file" style="margin-right: 5px;"></i>
                    <span>Waivers</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div style="width:100%; margin-bottom:10px;">
                        <b>Waivers</b>
                    </div>
                    <div *ngIf="waiverItems.length == 0">
                        No waivers have been signed for this booking.
                    </div>

                    <p-table *ngIf="waiverItems.length > 0" [value]="waiverItems">
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width:15%">Waiver ID</th>
                                <th style="width:20%">Date Signed</th>
                                <th style="width:50%">Signee</th>
                                <th style="width:15%">Participant</th>
                                <th></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-wi>
                            <tr>
                                <td>{{wi.waiveridhr}}</td>
                                <td>{{wi.signeddate | date:'dd/MM/yyyy'}}</td>
                                <td>{{wi.firstname}} {{wi.lastname}}</td>
                                 <td *ngIf="wi.isparticipant"><span style="color:#22c55e; text-align: center;" class="pi pi-check"></span></td>
                                 <td *ngIf="!wi.isparticipant"><span style="color: #ef4444; text-align: center; " class="pi pi-times"></span></td>
                                <td>
                                    <button pButton type="button" style="height: 50px; width: 115px;margin-left:10px" class="p-button p-button p-button-success" (click)="viewwaiver(wi.waiverid)"> 
                                        <span class="pi pi-file-pdf" style="margin-right:8px;"></span>
                                        <span>View</span>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="wi.children != null && wi.children.length > 0">
                                <td colspan="5" style="padding:20px;">   
                                    <b style="margin-left:10px;">Children covered by this waiver:</b>
                                    <p-table [value]="wi.children">
                                        <ng-template pTemplate="header">
                                            <tr>
                                                <th style="width:50%">Child Name</th>
                                                <th style="width:30%">Date of Birth</th>
                                                <th style="width:20%">Age</th>
                                                <th style="width:20%">Participant</th>
                                            </tr>
                                        </ng-template>
                                        <ng-template pTemplate="body" let-child>
                                            <tr>
                                                <td>{{child.firstname}} {{child.lastname}}</td>
                                                <td>{{child.dateofbirth | date:'dd/MM/yyyy'}}</td>
                                                <td>{{calculateChildAge(child.dateofbirth)}}</td>
                                                <td><span style="color:#22c55e; text-align: center;" class="pi pi-check"></span></td>
                                            </tr>
                                        </ng-template>  
                                    </p-table>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="History">
                <ng-template pTemplate="header">
                    <i class="pi pi-history" style="margin-right: 5px;"></i>
                    <span>History</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <p class="m-0 mb-3 p-0 text-600 line-height-3">
                        <span class="pi pi-info-circle" style="margin-right:5px;"></span>
                        History is deleted 3 months after the date of the booking.
                    </p>
                    <table style="width:100%; border-collapse:collapse;">
                        <thead>
                            <tr style="border-bottom:2px solid #dee2e6;">
                                <th style="text-align:left; padding:8px 12px; width:150px; white-space:nowrap;">Date/Time</th>
                                <th style="text-align:left; padding:8px 12px;">History Item</th>
                                <th style="text-align:left; padding:8px 12px; width:140px;">User</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let hi of historyItems; let i = index"
                                [style.background-color]="i % 2 === 0 ? '#f8f9fa' : '#ffffff'">
                                <td style="padding:8px 12px; white-space:nowrap; vertical-align:top;">{{hi.itemdatetime | date:'dd/MM/yyyy HH:mm'}}</td>
                                <td style="padding:8px 12px; word-break:break-word; vertical-align:top;"><span *ngIf="(hi.historyitem ?? '').length <= historyLimit || expandedHistory.has(i)">{{hi.historyitem}}</span><span *ngIf="(hi.historyitem ?? '').length > historyLimit && !expandedHistory.has(i)">{{hi.historyitem.substring(0, historyLimit).trimEnd()}}&hellip;<button type="button" class="history-more" title="Show the whole entry" (click)="toggleHistory(i)">more</button></span><button type="button" *ngIf="(hi.historyitem ?? '').length > historyLimit && expandedHistory.has(i)" class="history-more" title="Show less" (click)="toggleHistory(i)">less</button></td>
                                <td style="padding:8px 12px; vertical-align:top;">{{hi.user?.name}}</td>
                            </tr>
                        </tbody>
                    </table>
                </ng-template>
            </p-tabPanel>

            <p-tabPanel header="Notes" >
                <ng-template pTemplate="header">
                    <i class="pi pi-copy" style="margin-right: 5px;"></i>
                    <span *ngIf="(seriesLocked ? seriesNotes : NewBooking.notes) == null || (seriesLocked && seriesNotes == '')">Notes</span>
                    <span *ngIf="(seriesLocked ? seriesNotes : NewBooking.notes) != null && !(seriesLocked && seriesNotes == '')" style="color:red;">Notes</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div style="width:100%; margin-bottom:10px;">
                        <b>Notes</b>
                    </div>

                    <!-- A series has one set of notes for every date, changed on Edit Series. -->
                    <div *ngIf="seriesLocked" style="width:100%;">
                        <textarea pInputTextarea [ngModel]="seriesNotes" id="notesName" type="text" style="width:100%;" readonly></textarea>
                        <div style="margin-top:8px;color:#6d28d9;">These are the notes for the whole series. Change them on Edit Series.</div>
                    </div>

                    <div *ngIf="!seriesLocked" style="width:100%;">
                        <textarea pInputTextarea [(ngModel)]="NewBooking.notes" id="notesName" type="text"  style="width:100%;"></textarea>
                    </div>

                    <div *ngIf="!seriesLocked" style="clear:both;">
                        <button pButton type="button" style="height: 50px; width: 164px;margin-top:20px;" class="p-button p-button p-button-success" (click)="saveNotes()"> 
                            <span class="pi pi-save" style="margin-right:8px;"></span>
                            <span>Save Notes</span>
                        </button> &nbsp;
                    </div>
                </ng-template>

            </p-tabPanel>

            <p-tabPanel header="Tasks" (click)="loadTasks()">
                <ng-template pTemplate="header">
                    <i class="pi pi-paperclip" style="margin-right: 5px;"></i>
                    <span>Tasks</span>
                </ng-template>
                <ng-template pTemplate="body">
                    <div style="width:100%; margin-bottom:10px;">
                        <b>Tasks</b>
                    </div>
                    <!-- <div style="width: 100%;margin-bottom: 10px;border-radius: 10px;background-color: #80d6a4;text-align: center;padding: 20px;color: white;">
                        TASKS ARE COMING SOON! - Please let us know if you would like to be part of our beta programme <br>and get early access to up and coming features.
                    </div> -->
                    <div *ngIf="NewBooking.customer.email != ''">
                        <p-table [value]="allTasks">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width:55%">Task Name</th>
                                    <!-- <th style="width:20%">Status</th> -->
                                    <th style="width:20%">Send Date</th>
                                    <th style="width:5%">&nbsp;</th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-tasks let-index>
                                <tr>
                                    <td>{{tasks.bookingtasktypename}}</td>
                                    <!-- <td *ngIf="tasks.sent == false"><span class="pi pi-clock" style="margin-right:8px;"></span>Not Sent</td>
                                    <td *ngIf="tasks.sent == true"><span class="pi pi-send" style="margin-right:8px;"></span>Sent</td> -->
                                    <td>{{tasks.senddate | date:'dd/MM/yyyy HH:mm' : 'UTC'}}</td>
                                    <td>
                                        <button pButton pRipple type="button" class="p-button p-element p-button-danger" (click)="deleteTask(tasks)">
                                        <span class="pi pi-trash" style="margin-right:8px;"></span>
                                        Delete</button>
                                    </td>
                                    
                                </tr>
                            </ng-template>
                        </p-table>

                        <div style="clear:both; margin-top:20px;" >
                            <label for="ddlPackage" class="font-medium">Select a Task from the list below to add to the booking.</label><br>
                            <p-dropdown [style]="{'width': '300px'}" [options]="bookingTasks" [(ngModel)]="SelectedTask" placeholder="Select a Task" [showClear]="true" optionLabel="name"></p-dropdown>
                            <button pButton type="button" style="height: 50px; width: 164px;margin-top:20px;margin-left:10px" class="p-button p-button p-button-success" (click)="saveTask()"> 
                                <span class="pi pi-save" style="margin-right:8px;"></span>
                                <span>Add Task</span>
                            </button> &nbsp;
                            <div *ngIf="showTaskError" class="text-danger" Style="margin-left:10px;margin-top:10px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a Task to add.</div>
                        </div>
                    </div>
                    <div *ngIf="NewBooking.customer.email == ''">
                        There are no tasks associated with this booking as it is a walk-in booking.
                    </div>
                </ng-template>

            </p-tabPanel>
            
        </p-tabView>
            </div>
          </div>
          <div class="col-12 md:col-4">
            <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:16px;">
           <div style="font-weight: bold; margin-bottom: 10px;font-size: 20px;">Booking Summary</div>
           
            <div *ngIf="BookingSummary">
                <div class="summary-items-grid">
                <div style="margin-bottom: 12px;">
                    <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Sales ID</b> : {{BookingSummary.bookingIdHR}}
                </div>
                <div style="margin-bottom: 12px;">
                    <span class="pi pi-calendar" style="margin-right: 10px;"></span><b>Start Date/Time</b> : {{BookingSummary.startTime | date:'dd/MM/yyyy HH:mm' : 'UTC'}}
                </div>
                <div style="margin-bottom: 12px;">
                    <span class="pi pi-user" style="margin-right: 10px;"></span><b>Customer</b> : {{BookingSummary.customerAddress}}
                </div>
                <div style="margin-bottom: 12px;">
                    <span class="pi pi-box" style="margin-right: 10px;"></span><b>Package</b> : {{BookingSummary.packageName}}
                </div>
                <div style="margin-bottom: 12px;">
                    <span class="pi pi-users" style="margin-right: 10px;"></span><b>Admissions</b> : {{BookingSummary.admissions}}
                </div>

                <div *ngIf="BookingSummary.upgradetext != ''" style="margin-bottom: 12px;">
                    <span class="pi pi-arrow-up" style="margin-right: 10px;"></span><b>Upgrade</b> : {{BookingSummary.upgradetext}}
                </div>

                <div *ngIf="BookingSummary.addontext != ''" style="margin-bottom: 12px;">
                    <span class="pi pi-arrow-circle-up" style="margin-right: 10px;"></span><b>Add-Ons</b> : {{BookingSummary.addontext}}
                </div>

                <div *ngIf="BookingSummary.extras != ''" style="margin-bottom: 12px;">
                    <span class="pi pi-star" style="margin-right: 10px;"></span><b>Extras</b> : {{BookingSummary.extras}}
                </div>

                <div *ngIf="BookingSummary.totalbookingfees > 0" style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Booking Fee</b> : {{BookingSummary.totalbookingfees | currency:CurrencySymbol }}
                </div>

                <!-- A series is paid as a whole, so one date's money says nothing useful. -->
                <ng-container *ngIf="!seriesLocked">
                <div style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Sales Value</b> : {{BookingSummary.total | currency:CurrencySymbol }}
                </div>

                <div *ngIf="BookingSummary.totaldiscounts > 0" style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Discounts</b> : {{BookingSummary.totaldiscounts | currency:CurrencySymbol }}
                </div>

                <div *ngIf="BookingSummary.outstanding > 0" style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Paid</b> : <span>{{BookingSummary.paid | currency:CurrencySymbol }}</span>
                </div>
                <div *ngIf="BookingSummary.outstanding <= 0" style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Paid</b> : {{BookingSummary.paid | currency:CurrencySymbol }}
                </div>

                <div *ngIf="BookingSummary.outstanding > 0" style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Outstanding</b> : <span style="color: red; font-weight: bold;">{{BookingSummary.outstanding | currency:CurrencySymbol }}</span>
                </div>
                <div *ngIf="BookingSummary.outstanding <= 0" style="margin-bottom: 12px;">
                    <span class="pi pi-pound" style="margin-right: 10px;"></span><b>Outstanding</b> : {{BookingSummary.outstanding | currency:CurrencySymbol }}
                </div>
                </ng-container>
                </div><!-- /summary-items-grid -->

                <div style="margin-top: 4px;">

                <div *ngIf="SummaryItinerary" >
                    <span class="pi pi-list" style="margin-right: 10px;"></span><b>Itinerary</b>:

                    <div style="margin-top:5px; margin-bottom:10px;">
                            <table [cellPadding]="3" >
        
                                <tr style="border-bottom: 1px solid #dddddd" *ngFor="let itin of (NewBooking.itineraryEX || [])">
                                    <td>&nbsp;</td>
                                    <td>
                                    <b>{{itin.resource}}</b>
                                    </td>
                                    <td>
                                        {{itin.starttime}}
                                    </td>
                                    <td >
                                        {{itin.people}}&nbsp;people
                                    </td>

                                </tr>
        
                                <tr style="border-bottom: 1px solid #dddddd">
                                    <td>&nbsp;</td>
                                    <td>
                                        <b>End:</b>
                                    </td>
                                    <td>
                                        {{addMs(BookingSummary.endTime, 1)| date:'HH:mm' : 'UTC'}}
                                    </td>
                                    <td>&nbsp;</td>
                                </tr>
                            </table>
                    </div>
                </div>

                <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom: 12px;">
                    <span><span class="pi pi-envelope" style="margin-right: 10px;"></span><b>Email</b> : {{BookingSummary.customerEmail}}</span>
                    <button pButton type="button" style="height: 25px; width: 25px; flex-shrink:0; margin-left:6px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="sendanemail(bookingFromClick.bookingdata.bookingid)">
                        <span class="pi pi-envelope" style="margin-left: -8px; font-size: 15px;"></span>
                    </button>
                </div>
                <div style="display:flex; align-items:center; justify-content:space-between; margin-bottom: 12px;">
                    <span><span class="pi pi-mobile" style="margin-right: 10px;"></span><b>Mobile</b> : {{BookingSummary.customerMobile}}</span>
                    <button pButton type="button" style="height: 25px; width: 25px; flex-shrink:0; margin-left:6px;" class="p-button-sm p-element p-ripple p-button p-component" (click)="makeacall(bookingFromClick.bookingdata.bookingid)">
                        <span class="pi pi-mobile" style="margin-left: -8px; font-size: 15px;"></span>
                    </button>
                </div>

                <div style="margin-bottom: 12px;">
                    <span class="pi pi-file" style="margin-right: 10px;"></span><b>Notes</b> : {{seriesLocked ? seriesNotes : BookingSummary.notes}}
                </div>

                <div style="display:flex; flex-direction:column; gap:8px; margin-top:16px;">
                <button *ngIf="BookingSummary.customerEmail != ''" pButton type="button" style="width:100%; height:50px;" class="p-button p-button p-button-warning" (click)="sendEmailConfirmation()">
                    <span class="pi pi-envelope" style="margin-right:8px;"></span>
                    <span>Resend Email Confirmation</span>
                </button>

                <button *ngIf="BookingSummary.customerMobile != ''" disabled="true" pButton type="button" style="width:100%; height:50px;" class="p-button p-button p-button-warning" (click)="sendSMSConfirmation()">
                    <span class="pi pi-mobile" style="margin-right:8px;"></span>
                    <span>Resend SMS Confirmation</span>
                </button>
 
                <button pButton type="button" style="width:100%; height:50px;" class="p-button p-button p-button-success" (click)="printConfirmation()">
                    <span class="pi pi-print" style="margin-right:8px;"></span>
                    <span>Reprint Confirmation</span>
                </button>
                </div><!-- /action-buttons row -->

            </div>
            </div>
          </div>
        </div><!-- /col-4 -->
      </div><!-- /grid -->

        </p-tabPanel>

        <p-tabPanel header="Advanced Edit" [disabled]="seriesLocked">
            <ng-template pTemplate="header">
                <i class="pi pi-exclamation-triangle" style="margin-right: 5px;"></i>
                <span>Advanced Edit</span>
            </ng-template>
            <ng-template pTemplate="body">
                <!-- Warning -->
                <div style="background:#fff3cd; border:1px solid #ffc107; border-left:4px solid #f59e0b; border-radius:6px; padding:16px; margin-bottom:24px; display:flex; align-items:flex-start; gap:12px;">
                    <span class="pi pi-exclamation-triangle" style="color:#f59e0b; font-size:1.4rem; flex-shrink:0; margin-top:2px;"></span>
                    <div>
                        <div style="font-weight:700; color:#92400e; font-size:1rem; margin-bottom:6px;">Advanced Editing Warning</div>
                        <div style="color:#78350f; line-height:1.6;">Advanced editing will not check availability for your changes, please ensure you have checked that the changes you are making are valid, failure to do so could result in double bookings.</div>
                    </div>
                </div>

                <!-- Change Resource -->
                <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:24px;" *ngIf="hasAdvancedEditResources || hasAnyComplexResources">
                    <div style="font-weight:700; font-size:1.1rem; margin-bottom:16px; padding-bottom:8px; border-bottom:1px solid #e2e8f0;">
                        <span class="pi pi-clone" style="margin-right:8px; color:#64748b;"></span>Change Resource
                    </div>

                    <!-- Select from all resources toggle -->
                    <div style="background:#eff6ff; border:1px solid #bfdbfe; border-left:4px solid #3b82f6; border-radius:6px; padding:14px; margin-bottom:20px;">
                        <div style="font-weight:700; color:#1e40af; font-size:0.95rem; margin-bottom:6px;">Select from all Resources</div>
                        <div style="color:#1e3a8a; line-height:1.6; margin-bottom:10px;">Would you like to select from all resources? This will allow you to change this resource to any of your resources. Please check that this resource is both appropriate and you have checked the capacity of that resource.</div>
                        <div style="display:flex; align-items:center; gap:10px; flex-wrap:wrap;">
                            <p-inputSwitch [(ngModel)]="selectFromAllResources" (onChange)="onSelectFromAllResourcesChange()"></p-inputSwitch>
                            <span style="color:#1e40af; font-weight:600;">{{ selectFromAllResources ? 'Yes' : 'No' }}</span>
                            <span *ngIf="allVenueResourcesLoading" style="color:#64748b;">
                                <span class="pi pi-spin pi-spinner" style="margin-right:4px;"></span>Loading resources...
                            </span>
                        </div>
                    </div>

                    <ng-container *ngFor="let pr of PossibleResources">
                        <div *ngIf="pr.mode === 'COMPLEX' && ((pr.selectionmode === 'SYSTEMANY' || pr.selectionmode === 'SYSTEMLIST') || selectFromAllResources)" style="margin-bottom:16px;">
                            <label class="font-medium" style="display:block; margin-bottom:8px;">{{pr.name}}</label>
                            <p-dropdown
                                [options]="selectFromAllResources ? allVenueResources : pr.selectableresources"
                                [(ngModel)]="advancedEditResourceSelections[pr.id]"
                                optionLabel="name"
                                placeholder="Select a Resource"
                                [style]="{'min-width':'260px'}"
                                appendTo="body">
                            </p-dropdown>
                        </div>
                    </ng-container>
                </div>

                <!-- Change Date / Time -->
                <div class="surface-card p-4 shadow-2 border-round" style="margin-bottom:24px;">
                    <div (click)="toggleAdvancedEditDateTime()"
                         style="font-weight:700; font-size:1.1rem; padding-bottom:8px; cursor:pointer; display:flex; align-items:center; justify-content:space-between;"
                         [style.margin-bottom]="advancedEditDateTimeExpanded ? '16px' : '0'"
                         [style.border-bottom]="advancedEditDateTimeExpanded ? '1px solid #e2e8f0' : 'none'">
                        <span>
                            <span class="pi pi-calendar" style="margin-right:8px; color:#64748b;"></span>Change Date / Time
                        </span>
                        <span [class]="advancedEditDateTimeExpanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'" style="color:#64748b;"></span>
                    </div>

                    <div *ngIf="advancedEditDateTimeExpanded">
                        <div style="background:#fff3cd; border:1px solid #ffc107; border-left:4px solid #f59e0b; border-radius:6px; padding:16px; margin-bottom:16px; display:flex; align-items:flex-start; gap:12px;">
                            <span class="pi pi-exclamation-triangle" style="color:#f59e0b; font-size:1.4rem; flex-shrink:0; margin-top:2px;"></span>
                            <div style="color:#78350f; line-height:1.6;">Changing the Date and/or Time will move the entire booking (including associated resources) to the new Date/Time. This does not check availability and may cause overbookings — please verify that your chosen Date/Time is available before saving.</div>
                        </div>
                        <div style="margin-bottom:16px;">
                            <label class="font-medium" style="display:block; margin-bottom:8px;">Date</label>
                            <p-calendar [(ngModel)]="advancedEditDate" [showIcon]="true" dateFormat="dd/mm/yy" firstDayOfWeek="1" appendTo="body" (onSelect)="getAdvancedEditTimes()"></p-calendar>
                        </div>

                        <div *ngIf="advancedEditTimesLoading" style="color:#64748b; margin-top:4px;">
                            <span class="pi pi-spin pi-spinner" style="margin-right:6px;"></span>Loading times...
                        </div>

                        <div *ngIf="!advancedEditTimesLoading && advancedEditAllTimes && advancedEditAllTimes.length > 0">
                            <label class="font-medium" style="display:block; margin-bottom:8px;">Time</label>
                            <div style="display:grid; grid-template-columns: repeat(auto-fill, 110px); gap:8px;">
                                <button *ngFor="let t of advancedEditAllTimes" pButton type="button"
                                    style="height:44px; width:100%; display:flex !important; align-items:center !important; justify-content:center !important; gap:6px;"
                                    [ngClass]="advancedEditSelectedTime?.time === t.time ? 'p-button p-button-primary' : 'p-button p-button-outlined p-button-secondary'"
                                    (click)="advancedEditSelectedTime = t">
                                    <span class="pi pi-clock"></span>
                                    <span>{{ t.time | date:'HH:mm' : 'UTC' }}</span>
                                </button>
                            </div>
                        </div>

                        <div *ngIf="!advancedEditTimesLoading && advancedEditDate && advancedEditAllTimes?.length === 0" style="color:#64748b; font-style:italic; margin-top:4px;">
                            No times found for the selected date.
                        </div>
                    </div>
                </div>

                <!-- Save -->
                <div>
                    <button pButton type="button" style="height:50px;" class="p-button p-button-warning" (click)="saveAdvancedEdit()">
                        <span class="pi pi-save" style="margin-right:8px;"></span>
                        <span>Save Changes (No Availability Check)</span>
                    </button>
                </div>
            </ng-template>
        </p-tabPanel>

    </p-tabView>
</div>
